import './style.less';

export default function($log, $stateParams, $state, AuthClass) {
  'ngInject';

  const vm = this;
  this.$onInit = activate;

  vm.year = new Date().getFullYear();
  vm.prolaeraLogo = '//d4znxc3tx8unj.cloudfront.net/prolaeraLogo.png';

  vm.signup = function() {
    vm.error = false;
    AuthClass.signup(vm.formData.email, vm.password, $stateParams.company_id, function(error, response) {
      if (error) {
        vm.error = 'The user already exists.';
        $log.error(error);
        throw error;
      }
      login(response.email, vm.password);
    });
  };

  function login(email, password) {
    AuthClass.login(email, password, function(err) {
      if (err) {
        vm.message = true;
        throw err;
      }
    });
  }

  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function activate() {
    $log.debug('Users registration controller activated');
    if (!$stateParams.email) return $state.go('login');

    const email = decodeURIComponent($stateParams.email);

    if (!validateEmail(email)) return $state.go('login');

    vm.formData = { email };
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/registration/index.js